module.exports = __webpack_public_path__ + "img/28.380244b0.jpg";